export default {
    // "createBy": 0,
    // "createTime": "2019-12-05 21:36:46",
    // "updateBy": 0,
    // "treeId": "test",
    // "menuId": "test",
    // "name": "测试",
    // "parentId": "__ROOT__",
    // "sort": 200100,
    // "url": "/test",
    // "target": "",
    // "visible": "1",
    // "icon": "el-icon-location",
    // "children": [
	//
    // ]
};
